import { FC } from 'react';
import animation from './loading.lotti.json';
import { Player } from '@lottiefiles/react-lottie-player';
import { Container } from '@mui/material';

/**
 * LoadingPage
 */
const LoadingPage: FC = () => {
  return (
    <Container maxWidth="sm">
      <Player style={{ width: '100%' }} speed={2} autoplay keepLastFrame src={animation} />
    </Container>
  );
};

export default LoadingPage;
